import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import GridContainer from 'components/Grid/GridContainer';

// Icons
import Liquid from "../../Dashboard/Extra/Slideer/Tables/Icons/Liquid.png"
import Bittrex from "../../Dashboard/Extra/Slideer/Tables/Icons/Bittrex.png"
import DragonEx from "../../Dashboard/Extra/Slideer/Tables/Icons/DragonEx.png"
import Bitfinex from "../../Dashboard/Extra/Slideer/Tables/Icons/Bitfinex.png"
import Bitstamp from "../../Dashboard/Extra/Slideer/Tables/Icons/Bitstamp (light).png"


const useStyles = makeStyles({
    table: {
      minWidth: 650,
    },
  });
  
  function createData(name, calories, fat, carbs) {
    return { name, calories, fat, carbs };
  }
  
  const rows = [
    createData(
      <a href="#">
        <GridContainer>
          <img style={{marginTop:"7px"}} width="30" height="30" src={Liquid} alt="fireSpot"/>
          <p style={{color:"#7eb7b7"}}>BUSD/USDT</p>
        </GridContainer>
      </a>,
      
      "Sell",

      <a href="#">
        <GridContainer>
          <img style={{marginTop:"7px"}} width="30" height="30" src={Liquid} alt="fireSpot"/>
          <p style={{color:"#7eb7b7"}}>DEXE/ETH</p>
        </GridContainer>
      </a>, 
      "Strong-Buy"),

      createData(
        <a href="#">
          <GridContainer>
            <img style={{marginTop:"7px"}} width="30" height="30" src={Bittrex} alt="fireSpot"/>
            <p style={{color:"#7eb7b7"}}>DUSK/BTC	</p>
          </GridContainer>
        </a>,
        
        "Sell",
  
        <a href="#">
          <GridContainer>
            <img style={{marginTop:"7px"}} width="30" height="30" src={DragonEx} alt="fireSpot"/>
            <p style={{color:"#7eb7b7"}}>ANKR/BTC</p>
          </GridContainer>
        </a>, 
        "Strong-Buy"),
        
        createData(
          <a href="#">
            <GridContainer>
              <img style={{marginTop:"7px"}} width="30" height="30" src={Bitfinex} alt="fireSpot"/>
              <p style={{color:"#7eb7b7"}}>BNBUP/USDT</p>
            </GridContainer>
          </a>,
          
          "Sell",
    
          <a href="#">
            <GridContainer>
              <img style={{marginTop:"7px"}} width="30" height="30" src={Bitstamp} alt="fireSpot"/>
              <p style={{color:"#7eb7b7"}}>BTCST/USDT</p>
            </GridContainer>
          </a>, 
          "Strong-Buy"),

          createData(
            <a href="#">
              <GridContainer>
                <img style={{marginTop:"7px"}} width="30" height="30" src={Liquid} alt="fireSpot"/>
                <p style={{color:"#7eb7b7"}}>CHZ/USDT</p>
              </GridContainer>
            </a>,
            
            "Sell",
      
            <a href="#">
              <GridContainer>
                <img style={{marginTop:"7px"}} width="30" height="30" src={Bittrex} alt="fireSpot"/>
                <p style={{color:"#7eb7b7"}}>ADA/TUSD</p>
              </GridContainer>
            </a>, 
            "Strong-Buy"),

            createData(
              <a href="#">
                <GridContainer>
                  <img style={{marginTop:"7px"}} width="30" height="30" src={DragonEx} alt="fireSpot"/>
                  <p style={{color:"#7eb7b7"}}>MATIC/USDT</p>
                </GridContainer>
              </a>,
              
              "Sell",
        
              <a href="#">
                <GridContainer>
                  <img style={{marginTop:"7px"}} width="30" height="30" src={Bitfinex} alt="fireSpot"/>
                  <p style={{color:"#7eb7b7"}}>ADA/USDT</p>
                </GridContainer>
              </a>, 
              "Strong-Buy"),
  ];
  
  export default function DenseTable() {
    const classes = useStyles();
    // TradingPair, Signal
    return (
      <TableContainer component={Paper}>
        <Table className={classes.table} size="small" aria-label="a dense table">
          <TableHead style={{background:"linear-gradient(60deg, #1dbfcd, #c250e0)"}}>
            <TableRow>
              <TableCell>Trading Pair</TableCell>
              <TableCell align="left">Signal</TableCell>
              <TableCell align="left">TradingPair</TableCell>
              <TableCell align="center">Signal</TableCell>
              {/* <TableCell align="right">Protein&nbsp;(g)</TableCell> */}
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map((row) => (
              <TableRow key={row.name}>
                <TableCell component="th" scope="row">
                  {row.name}
                </TableCell>
                <TableCell align="left">{row.calories}</TableCell>
                <TableCell align="center">{row.fat}</TableCell>
                <TableCell align="center">{row.carbs}</TableCell>
                {/* <TableCell align="right">{row.protein}</TableCell> */}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      
    );
  }